const contractStatementMapper = (resp) => {
    var _a, _b, _c;
    if (resp && (resp === null || resp === void 0 ? void 0 : resp.data) && ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.contractNoteList)) {
        return (_c = (_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.contractNoteList) === null || _c === void 0 ? void 0 : _c.map((x) => {
            return {
                attId: x.attId,
                rank: x.rank,
                fileType: x.fileType,
                segment: x.segment.toUpperCase(),
                mailId: x.mailId,
                fileName: x.fileName,
                filePath: x.filePath,
                fileDate: x.fileDate,
            };
        });
    }
    return [];
};
export default contractStatementMapper;
